import React from "react";
import {
    Modal,
    Box,
    Typography,
    IconButton,
    Stack,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslation } from "react-i18next";

const ModalWrapper = ({
    open,
    setOpen,
    onClose,
    title,
    subtitle,
    actions,
    content,
    width = "50vw"
}) => {
    const { t } = useTranslation();
    
    // Set default translated values if not provided
    const finalTitle = title || t('TITLES.CONFIRM_ACTION');
    const finalSubtitle = subtitle || t('TITLES.REVIEW_DETAILS_AND_CONTINUE');
    const handleClose = () => {
        if (onClose) onClose();
        setOpen(false);
    };

    return (
        <Modal open={open} onClose={handleClose}>
            <Box
                sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: { xs: "90%", sm: width },
                    bgcolor: "background.paper",
                    boxShadow: 24,
                    borderRadius: 2,
                    p: 2,
                    outline: "none",
                    maxHeight: "80vh", // limit total modal height
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                {/* Header */}
                <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    sx={{ flexShrink: 0 }}
                >
                    <Box>
                        <Typography variant="h6" fontWeight={600}>
                            {finalTitle}
                        </Typography>
                        {finalSubtitle && (
                            <Typography variant="body2" fontSize={"11px"} color="text.secondary">
                                {finalSubtitle}
                            </Typography>
                        )}
                    </Box>
                    <IconButton onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </Stack>

                {/* Content */}
                <Box
                    sx={{
                        flexGrow: 1,
                        overflowY: "auto",
                        my: 2,
                        minHeight: '200px',
                        p: 1,
                        pr: 1, // avoid scrollbar overlap
                    }}
                >
                    {content}
                </Box>

                {/* Actions */}
                {actions && (
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            gap: 1,
                            flexShrink: 0,
                            pt: 1,
                        }}
                    >
                        {actions}
                    </Box>
                )}
            </Box>
        </Modal>
    );
};

export default ModalWrapper;
